module.exports = __webpack_public_path__ + "img/banner-03.b9e35aa0.png";